export enum AdventuresTabs {
  ActiveAdventures = 'active',
  MyAdventures = 'myAdventures',
}
